import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CommonModalComponent } from '../modal/common-modal/common-modal.component';
import { BannerService } from '@service/banner.service';
import { LocalSettingsKey } from '@shared/types/local-settings';
import { ConfigsStorage } from '@storage/configs.storage';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html'
})
export class BannerComponent implements OnInit {
    isEnabled = false;
    @ViewChild('bannerBody', { static: true }) bannerBody: TemplateRef<any>;

    constructor(
        private modalService: BsModalService,
        private bannerService: BannerService,
        public configsStorage: ConfigsStorage
    ) { }

    ngOnInit() {
        this.isEnabled = !this.bannerService.isBannerSeen();
        if (this.isEnabled) {
            // clear previous banner flags from localstorage
            this.clearOtherBannerFlags();
            this.openBannerModal();
        }
    }

    clearOtherBannerFlags(): void {
        const currentKey = (this.configsStorage.config.WEB_BANNER_KEY || '');
        const bannerKeys = Object.keys(localStorage).filter(key => key !== currentKey && key.startsWith(LocalSettingsKey.IS_BANNER_SEEN));
        (bannerKeys || []).forEach(key => localStorage.removeItem(key));
    }

    openBannerModal(): void {
        const initialState = {
            modalTitleText: 'LOGIN_SUIT_BANNER',
            modalBody: this.bannerBody
        };
        const classParam = this.configsStorage.config.WEB_BANNER_URL ? 'modal-dialog-centered modal-large' : 'modal-dialog-centered modal-medium'
        const bannerModal = this.modalService.show(CommonModalComponent, { class: classParam, initialState, ignoreBackdropClick: true });
        bannerModal.content.onClose.subscribe(
            response => {
                this.isEnabled = false;
                this.bannerService.setIsBannerSeen();
            }
        );
    }
}